module.exports = __webpack_public_path__ + "img/image17@2x.4ba79861.png";